import { Ng1StateDeclaration } from '@uirouter/angularjs';

const states: Ng1StateDeclaration[] = [
    {
        template: '<wt-tags-management-state class="flex-directive"></wt-tags-management-state>',
        name: 'tagsManagement',
        url: '/tagsManagement',
        data: {
            visible: false,
            displayName: 'Tags management'
        }
    }];

export default states;